/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_TitleInputs */

const en_ui_more_stats_title = /** @type {(inputs: Ui_More_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More stats`)
};

const de_ui_more_stats_title = /** @type {(inputs: Ui_More_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Werte`)
};

/**
* | output |
* | --- |
* | "More stats" |
*
* @param {Ui_More_Stats_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_title = /** @type {((inputs?: Ui_More_Stats_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_title(inputs)
	return de_ui_more_stats_title(inputs)
});